module.exports = __webpack_public_path__ + "static/media/complete-milestone-green.00457b80.svg";